/* eslint-disable react/no-multi-comp */
import { List, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { matchPath } from 'react-router-dom';
import useRouter from 'use-react-router';
import { Can } from '../../../../components/Can';
import { checkPermission } from '../../../../components/Can/Can';
import NavigationListItem from './NavigationListItem';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(3)
    }
}));

const NavigationList = (props: { pages: any[], depth: number, router?: any, onNavigationItemClick: () => void, }) => {
    const {pages, ...rest} = props;

    return (
        <List>
            {pages.reduce(
                (items, page) => reduceChildRoutes({items, page, ...rest}),
                []
            )}
        </List>
    );
};

const reduceChildRoutes = (props: { router?: any, items: any[], page: any, onNavigationItemClick: () => void, depth: number }) => {
    const {router, items, page, depth, onNavigationItemClick} = props;

    const key = page.title + '_' + Math.random();

    const unlessCheck = page.notPermission ? checkPermission(page.notPermission) : false;

    if (unlessCheck) return items;

    if (page.children) {
        const open = matchPath(router.location.pathname, {
            path: page.href,
            exact: false
        });

        items.push(
          <Can key={key} permission={page.permission}>
              <NavigationListItem
                depth={depth}
                icon={page.icon}
                label={page.label}
                open={Boolean(open)}
                title={page.title}
              >
                  <NavigationList
                    depth={depth + 1}
                    onNavigationItemClick={onNavigationItemClick}
                    pages={page.children}
                        router={router}
                    />
                </NavigationListItem>
            </Can>
        );
    } else {
        items.push(
          <Can key={key} permission={page.permission}>
              <NavigationListItem
                depth={depth}
                href={page.href}
                icon={page.icon}
                label={page.label}
                title={page.title}
                onNavigationItemClick={onNavigationItemClick}
              />
          </Can>
        );
    }

    return items;
};

const Navigation = (props: {
    className?: string,
    component?: any,
    pages: any[],
    title: string,
    onNavigationItemClick: () => void,
}) => {
    const {title, pages, className, component: Component = 'nav', onNavigationItemClick, ...rest} = props;

    const classes = useStyles();
    const router = useRouter();

    return (
        <Component
            {...rest}
            className={clsx(classes.root, className)}
        >
            {title && <Typography variant="overline">{title}</Typography>}
            <NavigationList
                depth={0}
                pages={pages}
                router={router}
                onNavigationItemClick={onNavigationItemClick}
            />
        </Component>
    );
};

export default Navigation;
